import { TextAreaQuestionnaire } from "./_components/TextAreaQuestionnaire";
import { SingleChoiceQuestionnaire } from "./_components/SingleChoiceQuestionnaire";
import { MultipleChoiceQuestionnaire } from "./_components/MultipleChoiceQuestionnaire";
import { SmartFieldQuestionnaire } from "./_components/SmartFieldQuestionnaire";
import { DropdownQuestionnaire } from "./_components/DropdownQuestionnaire";
import { DateSelectionQuestionnaire } from "./_components/DateSelectionQuestionnaire";
import { AddressFinderQuestionnaire } from "./_components/AddressFinderQuestionnaire";
import { FileInputQuestionnaire } from "./_components/FileInputQuestionnaire";
import { SubmissionSmartFieldPreviewContextProvider } from "context/RFQSubmittedResponseContext";
import { DetailModal } from "components/Pages/RFQDetail/RFQSubmission/RFQSubmissionView";
import { TableQuestionnaire } from "./_components/TableQuestionnaire";
import { SectionComponent } from "../SectionComponent";
import { QUESTION_TYPE_ID } from "../../../constants";
import { TableWithRowsQuestionnaire } from "./_components/TableWithRowsQuestionnaire";
import { TextLength } from "newui/features/Rfx/types/component-types";
import { isNotNullOrUndefined } from "newui/utils/objectUtil";

const showSmartField = (
	hasItem,
	isClientPreview,
	selectedValues,
	chosenType
) => {
	return (
		chosenType !== "other" &&
		(isClientPreview ||
			(!isClientPreview && hasItem) ||
			isNotNullOrUndefined(selectedValues))
	);
};

// supplier - bidder
export const renderQuestion = (
	question,
	index,
	hasDocuments,
	hasResources,
	hasPastProjects,
	disabled,
	rfxSubmissionData,
	isClientPreview = false,
	previewQuestion = null
) => {
	const answer = question?.answer?.answer;
	const company = rfxSubmissionData?.company;
	const isClientView = rfxSubmissionData?.isClientView;
	switch (question.type) {
		case QUESTION_TYPE_ID.SHORT_ANSWER:
			return (
				<TextAreaQuestionnaire
					key={index}
					textLength={TextLength.SHORT}
					{...question}
				/>
			);
		case QUESTION_TYPE_ID.PARAGRAPH:
			return (
				<TextAreaQuestionnaire
					key={index}
					textLength={TextLength.LONG}
					{...question}
				/>
			);
		case QUESTION_TYPE_ID.SINGLE_OPTION:
			return (
				<SingleChoiceQuestionnaire
					key={index}
					{...question}
					isClientPreview={isClientPreview}
					previewQuestion={previewQuestion}
				/>
			);
		case QUESTION_TYPE_ID.MULTIPLE_CHOICE:
			return (
				<MultipleChoiceQuestionnaire
					key={index}
					{...question}
					isClientPreview={isClientPreview}
					previewQuestion={previewQuestion}
				/>
			);
		case QUESTION_TYPE_ID.DROP_DOWN:
			return (
				<DropdownQuestionnaire
					key={index}
					{...question}
					isClientPreview={isClientPreview}
					previewQuestion={previewQuestion}
				/>
			);
		case QUESTION_TYPE_ID.DATE_SELECTION:
			return (
				<DateSelectionQuestionnaire
					key={index}
					{...question}
				/>
			);
		case QUESTION_TYPE_ID.ADDRESS_FINDER:
			return (
				<AddressFinderQuestionnaire
					key={index}
					{...question}
				/>
			);
		case QUESTION_TYPE_ID.PROJECT_EXPERIENCE:
			return showSmartField(
				hasPastProjects,
				isClientPreview || isClientView,
				answer?.selectedProjects,
				answer?.chosen_type
			) ? (
				<SubmissionSmartFieldPreviewContextProvider>
					<SmartFieldQuestionnaire
						key={index}
						smartField="Project Experience"
						isClientPreview={isClientPreview}
						{...question}
						answer={answer}
					/>
					<DetailModal company={company} />
				</SubmissionSmartFieldPreviewContextProvider>
			) : (
				<TextAreaQuestionnaire
					description="Maximum of 4500 characters."
					{...question}
					textLength={TextLength.L4500}
				/>
			);
		case QUESTION_TYPE_ID.KEY_PERSONNEL:
			return showSmartField(
				hasResources,
				isClientPreview || isClientView,
				answer?.selectedKeyPersonnel,
				answer?.chosen_type
			) ? (
				<SubmissionSmartFieldPreviewContextProvider>
					<SmartFieldQuestionnaire
						key={index}
						smartField="Key Personnel"
						isClientPreview={isClientPreview}
						{...question}
						answer={answer}
					/>
					<DetailModal company={company} />
				</SubmissionSmartFieldPreviewContextProvider>
			) : (
				<TextAreaQuestionnaire
					description="Maximum of 4500 characters."
					{...question}
					textLength={TextLength.L4500}
				/>
			);
		case QUESTION_TYPE_ID.CORPORATE_DOCUMENTS:
			return showSmartField(
				hasDocuments,
				isClientPreview || isClientView,
				answer?.selectedDocuments,
				answer?.chosen_type
			) ? (
				<SmartFieldQuestionnaire
					key={index}
					smartField="Corporate Documents"
					rfxInviteId={rfxSubmissionData?.id}
					isClientPreview={isClientPreview}
					{...question}
					answer={answer}
				/>
			) : (
				<FileInputQuestionnaire
					key={index}
					rfxInviteId={rfxSubmissionData?.id}
					{...question}
				/>
			);
		case QUESTION_TYPE_ID.FILE_UPLOAD:
			return (
				<FileInputQuestionnaire
					key={index}
					{...question}
					rfxInviteId={rfxSubmissionData?.id}
					singleFile={false}
				/>
			);
		case "section":
			return (
				<SectionComponent
					key={index}
					{...question}
				/>
			);
		case QUESTION_TYPE_ID.TABLE:
			return (
				<TableQuestionnaire
					key={index}
					tableQuestions={
						isClientPreview
							? (previewQuestion?.fields?.table ?? previewQuestion?.fields)
							: question?.fieldValue
					}
					{...question}
				/>
			);
		case QUESTION_TYPE_ID.TABLE_ROWS:
			return (
				<TableWithRowsQuestionnaire
					key={index}
					data={question?.fieldValue}
					headers={previewQuestion?.fields?.table ?? previewQuestion?.fields}
					isClientPreview={isClientPreview}
					{...question}
				/>
			);
		default:
			return null;
	}
};
